// @flow
import React, {
  type Node,
} from 'react';
import type {
  GroupByType,
} from 'chronos-types';

import downChevron from 'chronos-assets/images/down-chevron.svg';
import {
  Popup,
} from 'chronos-components';

import * as S from './styled';

const types: Array<GroupByType> = [
  'issues',
  'users',
  'projects',
];

type Props = {
  /**
   * wherer groupBy popup is open
   * */
  isOpen: boolean,
  /**
   * wherer groupBy popup is open
   * */
  setPopupVisible: { (value: boolean): void },
  /**
   * groupBy one of issues, epics, users, projects, versions.
   * */
  groupBy: GroupByType,
  /**
   * Function that is called after click some groupBy
   * */
  onGroupBy: { (type: GroupByType): void },
};

/**
 * Group By Picker
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](https://github.com/rahmonzoda)
 */
const GroupByPicker = ({
  isOpen,
  setPopupVisible,
  groupBy,
  onGroupBy,
}: Props): Node => (
  <S.PickerWrap>
    <Popup
      isOpen={isOpen}
      setPopupVisible={() => setPopupVisible(!isOpen)}
      handleOuterAction={() => setPopupVisible(false)}
      preferPlace="below"
      trigger={<S.PopupTrigger src={downChevron} />}
      triggerWidth="32px"
    >
      <S.PopupContent>
        <S.PopupInner>
          <S.PopupTitle>
            Group by
          </S.PopupTitle>
          <S.PickerList>
            {types.map(type => (
              <S.PickerListItem
                key={type}
                onClick={() => onGroupBy(type)}
                selected={groupBy === type}
              >
                {type}
              </S.PickerListItem>
            ))}
          </S.PickerList>
        </S.PopupInner>
      </S.PopupContent>
    </Popup>
  </S.PickerWrap>
);

GroupByPicker.defaultProps = {
  groupBy: null,
  onGroupBy: () => {},
  setPopupVisible: () => {},
};

export default GroupByPicker;
